module.exports = __webpack_public_path__ + "img/search_white.aa754470.svg";